import { BasicPagination, BtnPagination, SliderPagination, TablePagination } from '@playbooks/molecules/paginations';

type PaginationLayout = 'basic' | 'btn' | 'slider' | 'table';

const Pagination = ({
	layout = 'basic',
	meta,
	params,
	setParams,
	taskRunning = false,
	onClick = null,
	pageSizes,
	totalLabel,
}: {
	layout?: PaginationLayout;
	meta: any;
	params: any;
	setParams: any;
	taskRunning?: boolean;
	onClick?: any;
	pageSizes?: number[];
	totalLabel?: string;
}) => {
	const props = { meta, params, setParams, taskRunning, onClick, pageSizes, totalLabel };

	// Render
	switch (layout) {
		case 'basic':
			return <BasicPagination {...props} />;

		case 'btn':
			return <BtnPagination {...props} />;

		case 'slider':
			return <SliderPagination {...props} />;

		case 'table':
			return <TablePagination {...props} />;
	}
};

export { Pagination };
export type { PaginationLayout };
